<!--
 * @Author: huc 13588239351@sina.cn
 * @Date: 2023-02-03 14:25:15
 * @LastEditors: huc 13588239351@sina.cn
 * @LastEditTime: 2023-09-14 10:37:14
 * @FilePath: \foxmaintain\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app" ref="appRef">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      Height: null,
    };
  },
  methods: {
    resize() {
      this.$refs["appRef"].style.height = this.Height;
    },
  },
  mounted() {
    // console.log(this.$route.path)

    if (
      this.$mediaSize == "S" &&
      (this.$route.path == "/login" || this.$route.path == "/")
    ) {
      this.Height = getComputedStyle(this.$refs["appRef"]).height;
    }
  },
  beforeDestroyed() {
    if (this.$mediaSize == "S") {
      window.removeEventListener("resize", this.resize);
    }
  },
  watch: {
    $route(newRoute, oldRoute) {
      //console.log(newRoute, oldRoute)
      if (this.$mediaSize == "S") {
        if (
          newRoute.path == "/login" &&
          (oldRoute.path == "/" ||
            oldRoute.path == "/repairNew" ||
            oldRoute.path == "/repairDetail")
        ) {
          this.$refs["appRef"].style.height = "100%";
          window.addEventListener("resize", this.resize);
        } else if (newRoute.path == "/login" || oldRoute.path == "/login") {
          this.$refs["appRef"].style.height = "auto";
          window.removeEventListener("resize", this.resize);
        }
      }
    },
  },
};
</script>

<style>
html {
  /* iPhone6的375px尺寸作为16px基准，600px正好18px大小 */
  /* font-size: calc(100% + 2 * (100vw - 375px) / 225); */
}
@media screen and (min-width: 600px) {
  html {
    /* 600px-1000px每100像素宽字体增加1px(16px-20px) */
    font-size: calc(100% + 4 * (100vw - 600px) / 400);
  }
}
@media screen and (min-width: 1000px) {
  html {
    /* 1000px往后是每100像素0.5px增加 */
    font-size: calc(112.5% + 5 * (100vw - 1000px) / 1000);
  }
}

#app {
  font-family: Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.S #app {
  min-height: 100%;
  height: auto;
}
body {
  margin: 0;
  padding: 0;
}
body,
button,
input,
textarea {
  font-family: Microsoft YaHei;
}

.el-menu--horizontal {
  display: flex;
  flex-wrap: nowrap;
  border-bottom: solid 1px var(--el-menu-border-color);
  border-right: none;
}
.el-menu--popup {
  background: #fff !important;
}
.el-scrollbar__wrap {
  overflow: auto !important;
}

.S body {
  font-size: 1.25rem;
}
.S .el-message-box {
  width: 18rem;
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 !important;
}
</style>
